import React from 'react';
import { motion } from 'framer-motion';
import { Flower } from 'lucide-react';
import Icon from './Icon';
import { OrnDivider } from './Ornaments';
import { POOJA_DETAILS } from '../../lib/constants';

const THALI_IMG =
  'https://images.unsplash.com/photo-1666694051761-cd972857da30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxoaW5kdSUyMHBvb2phJTIwdGhhbGklMjBrYWxhc2hhJTIwcml0dWFsfGVufDB8fHx8MTc4MjIzODUyMXww&ixlib=rb-4.1.0&q=85';

const PoojaDetails = () => (
  <section
    id="pooja-details"
    data-testid="pooja-details-section"
    className="scroll-mt-24 bg-[linear-gradient(180deg,#FDFBF7,#F7EFD9)] py-14 md:py-20"
  >
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.6 }}
        className="text-center"
      >
        <OrnDivider className="mb-5" />
        <h2 className="font-serif text-3xl tracking-tight text-ink md:text-4xl lg:text-5xl">
          Pooja Details
        </h2>
      </motion.div>

      <div className="mt-14 grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
        {/* Left: arched thali image */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <div className="absolute -inset-3 -z-10 rounded-[999px_999px_20px_20px] bg-gold/15 blur-xl" />
          <div className="overflow-hidden rounded-[999px_999px_16px_16px] border-2 border-gold/40 shadow-[0_30px_70px_-30px_rgba(92,22,22,0.55)]">
            <img src={THALI_IMG} alt="Sacred pooja thali and samagri" className="h-[420px] w-full object-cover md:h-[500px]" />
          </div>
        </motion.div>

        {/* Right: details list */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="rounded-2xl border border-gold/25 bg-white/70 p-7 backdrop-blur-sm md:p-9"
        >
          <dl className="divide-y divide-gold/20">
            {POOJA_DETAILS.map((d) => (
              <div key={d.label} className="flex gap-4 py-4" data-testid={`detail-${d.label.replace(/\s+/g, '-').toLowerCase()}`}>
                <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-gold/40 text-gold-deep">
                  <Icon name={d.icon} className="h-4 w-4" strokeWidth={1.8} />
                </div>
                <div className="flex flex-1 flex-col gap-0.5 sm:flex-row sm:items-baseline sm:gap-3">
                  <dt className="w-40 shrink-0 font-sans text-xs uppercase tracking-[0.14em] text-gold-deep">
                    {d.label}
                  </dt>
                  <dd className="font-sans text-[15px] font-medium text-ink">{d.value}</dd>
                </div>
              </div>
            ))}
          </dl>

          <div className="mt-6 flex items-start gap-3 rounded-xl border border-gold/30 bg-[#FBF3D8]/70 px-4 py-3">
            <Flower className="mt-0.5 h-4 w-4 shrink-0 text-gold-deep" />
            <p className="font-sans text-sm text-ink/75">
              Pooja will be performed as per Sai Baba traditions to bring blessings and peace.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default PoojaDetails;
